import { Cell } from "@tanstack/react-table";
import { IInventoryPositionResponse } from "domain/Inventory/Models/IInventoryPositionResponse";
import { SBBox } from "modules/Commons";
import { SBNewTable } from "modules/Commons/SBDataDisplays/SBTable/SBNewTable";
import { useGlobalInventoryContext } from "modules/Inventory/components/SBGlobalInventoryInfoModal";
import React, { forwardRef, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { InventoryPositionSummarization } from "../InventoryPositionSummarization";
import { useInventoryPositionHeaders } from "./useInventoryPositionHeaders";

interface InventoryPositionTableProps {
	rows: IInventoryPositionResponse[];
	containerHeight?: number;
	count?: number;
	onScroll?: (event: React.UIEvent<HTMLDivElement>) => void;
}

const InventoryPositionTable = forwardRef(
	({ rows, containerHeight, count, onScroll }: InventoryPositionTableProps, ref: any) => {
		const { t } = useTranslation();
		const { headers } = useInventoryPositionHeaders();
		const [selectedItems, setSelectedItems] = useState<IInventoryPositionResponse[]>([]);
		const { openMenu, isOpen } = useContext(useGlobalInventoryContext);

		const handleClick = (cell: Cell<any, any>) => {
			if (cell.column.id === "inventory")
				openMenu((cell.row.original as IInventoryPositionResponse).id);
		};

		return (
			<SBBox>
				<InventoryPositionSummarization
					items={rows}
					selectedItems={selectedItems}
				/>
				<SBBox
					width={isOpen ? "50vw" : "100%"}
					style={{ transition: "all 0.25s ease", marginTop: "1rem" }}
				>
					<SBNewTable
						ref={ref}
						hasSelection
						virtualize
						title={t("inventoryPosition")}
						startRows={rows}
						defaultColumns={headers}
						onClick={handleClick}
						onSelect={(_, indices) =>
							setSelectedItems(
								(indices as string[]).map((i) => rows[+i]),
							)
						}
						containerHeight={containerHeight}
						totalCount={count}
						onScroll={onScroll}
					/>
				</SBBox>
			</SBBox>
		);
	},
);

export default InventoryPositionTable;
